import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'homey-empty',
  imports: [],
  templateUrl: './empty.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyComponent {

}
